import type { ChapterDetail } from "../types.js";

const angleLabels = { image: "画面与物件", voice: "人物口吻", tension: "悬念与反差", emotion: "情绪与关系", action: "具体行动" };

export function PlannedChapterTitleReceipt({ chapter }: { chapter: ChapterDetail }) {
  if (chapter.status === "final") {
    const finalReview = chapter.titleReview;
    return <section className="stage-detail-sections planned-title-receipt" aria-label="正文章名审定记录">
      <header><h3>章名审定</h3><span>{chapter.titleReviewCurrent ? "正文已定名" : "尚无对应当前正文的章名审定记录"}</span></header>
      {chapter.titleReviewCurrent && finalReview && <><p><strong>{finalReview.selected.title}</strong></p><p>{finalReview.selected.reason}</p><blockquote>正文依据：{finalReview.selected.evidence}</blockquote></>}
    </section>;
  }
  const review = chapter.provisionalTitleReview;
  if (!review) return <p className="ux-note">暂定章名：尚无章纲审名记录。正文完成后仍需复核定名。</p>;
  const current = chapter.provisionalTitleCurrent === true && chapter.title === review.selected.title;
  return <section className="stage-detail-sections planned-title-receipt" aria-label="章纲章名审定记录">
    <header><h3>章名审定</h3><span>{current ? "章纲已审名 · 待正文复核" : "历史章纲审名 · 当前版本需复核"}</span></header>
    <p><strong>{review.workingTitle} → {review.selected.title}</strong></p>
    <p>{review.selected.reason}</p>
    <details>
      <summary>查看 {review.candidates.length} 个候选与选择理由</summary>
      {review.candidates.map(candidate => <article key={candidate.title}>
        <h4>{candidate.title}{candidate.title === review.selected.title ? " · 选用" : ""}</h4>
        <p>{angleLabels[candidate.angle]} · {candidate.reason}</p>
        <p>{review.comparison.find(item => item.title === candidate.title)?.comment}</p>
        <blockquote>章纲依据：{candidate.evidence}</blockquote>
      </article>)}
      <p>整组目录：{review.directoryReason}</p>
      <p>剧透核对：{review.selected.spoilerReason}</p>
      <p className="ux-note">候选模型：{review.generator.model}；独立审名模型：{review.reviewer.model}。这是两个独立会话，依据是章纲，不是正文。</p>
    </details>
    <p className="ux-note">不为章名改动剧情。正文写成后重新核对实际内容；修改章纲或名称后，旧记录不会冒充当前审定结果。</p>
  </section>;
}
